import React from "react";
import InputSearch from "./Component/Search/Search";
import PickColumn from "./Component/PickColumn/PickColumn";
import Filter from "./Component/Filter/Filter";
import CreatedOn from "./Component/CreatedOn/CreatedOn";
import Action from "./Component/Action/Action";
import AddGroup from "./Component/AddGroup/AddGroup";
import {Sellers} from "./Component/Utils/Utils"
import {
  Container,
  Header,
  HeaderIconLeft,
  HeaderIconRight,
  HeaderTitle,
  TableBody,
  TableContainer,
  TableHeader,
  Title,
} from "./Component/TableComponent/Table";

export default function AddBuyerProducts() {
  const RowHeader = [
    "ProductID",
    "Status",
    "Product Name",
    "Product Cateogories",
    "Product HSN Code",
    "Assigned to",
    "Tags",
    "actions",
  ];
  // const { rows, isLoading, error } = Usefetch_Get(
  //   "http://localhost:4000/Table"
  // );
  const path = "/admin-dashboard/view-buyer/";

  return (
    <div>
      <Container>
        <Title message={'sdssd'} showImport={false}> Add Buyer</Title>
        <Header>
          <HeaderTitle>
            <HeaderIconLeft>
              <InputSearch />
              <PickColumn />
            </HeaderIconLeft>
            <HeaderIconRight>
              <Action />
              <Filter />
              <AddGroup />
              <CreatedOn />
            </HeaderIconRight>
          </HeaderTitle>
          <TableContainer>
            <TableHeader children={RowHeader} />
            <TableBody
              rows={Sellers}
              // isLoading={isLoading}
              // error={error}
              path={path}
            />
          </TableContainer>
        </Header>
      </Container>
    </div>
  );
}

// AddBuyerProducts